import React from 'react'

/* eslint-disable */
import { IconLookup } from '@fortawesome/fontawesome-common-types'
import { icon as getIconDefinition, IconParams } from '@fortawesome/fontawesome-svg-core'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export type BaseIconProps<P extends Record<string, unknown>> = SvgIconProps & P & { params?: IconParams }

export type OwnProps = {
  icon: IconLookup;
  spin?: boolean;
}

export type IconProps = BaseIconProps<OwnProps>

export const StyledSvgIcon = styled(SvgIcon)``

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(({ icon: iconLookup, params, spin, ...props }, ref) => {
  const def = getIconDefinition(iconLookup, params)

  if (!def) {
    return null
  }

  const [width, height, _ligature, _unicode, path] = def.icon

  const spinStyles = spin
    ? {
        '@keyframes spin': {
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
        },
        animation: 'spin 1s linear infinite',
      }
    : {}

  return (
    <StyledSvgIcon ref={ref} {...props} sx={{ ...spinStyles, ...props.sx }} viewBox={`0 0 ${width} ${height}`}>
      {
        // eslint-disable-next-line react/no-array-index-key
        Array.isArray(path) ? path.map((p, i) => <path key={i} d={p} />) : <path d={path} />
      }
    </StyledSvgIcon>
  )
})
